<template>
  <div class="product-grid__wrap">
    <div class="product-grid ProductList hidden-pocket product-visible-desk">
      <v-product
        v-for="(product, idx) in products"
        :key="idx"
        :product="product"
      ></v-product>
    </div>
    <div ref="container" class="swiper-container product-hidden-desk">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div class="swiper-slide" v-for="(product, idx) in products" :key="idx">
          <v-product :product="product"></v-product>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation } from "swiper/core";
import "swiper/swiper-bundle.css";
import vProduct from "./Product.vue";

Swiper.use([Navigation]);
export default {
  components: {
    vProduct,
  },
  selector: "#vue-product-grid",
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.swiper = new Swiper(this.$refs.container, {
      slidesPerView: "auto",
      spaceBetween: 20,
      loop: true,
      navigation: {
        prevEl: this.$refs.prev,
        nextEl: this.$refs.next,
      },
    });
  },
};
</script>

<style lang="scss" scoped>
.product-visible-desk {
  @media (max-width: 1200px) {
    display: none;
  }
}
.product-hidden-desk {
  display: none;
  @media (max-width: 1200px) {
    display: block;
  }
}
.product-grid {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  justify-content: center;
}
.swiper-slide {
  min-width: 200px;
  width: calc(25% - 20px);
}
</style>
